import { useCallback, useRef, useEffect } from "react";

/**
 * Handles the scroll event on a list table and fetches data if scrolled to the bottom..
 * @return {number} The calculate scroll position & call API if Height calculation is less than 2.
 */

const useDebounceScroll = (fetchAction) => {
  const timerDebounceRef = useRef();
  const lastScrollLeftRef = useRef(0); // Reference to store the last horizontal scroll position

  const handleDebounceScroll = useCallback(
    (e) => {
      if (timerDebounceRef.current) {
        clearTimeout(timerDebounceRef.current);
      }

      // Check if horizontal scroll position has changed
      const element = e.target;
      const currentScrollLeft = element.scrollLeft;

      // Only proceed if the horizontal scroll position has not changed
      if (lastScrollLeftRef.current === currentScrollLeft) {
        timerDebounceRef.current = setTimeout(() => {
          if (
            element.scrollHeight - element.scrollTop - element.clientHeight <
            2
          ) {
            fetchAction();
          }
        }, 500);
      }

      // Update the last horizontal scroll position
      lastScrollLeftRef.current = currentScrollLeft;
    },
    [fetchAction],
  );

  useEffect(() => {
    return () => {
      if (timerDebounceRef.current) {
        clearTimeout(timerDebounceRef.current);
      }
    };
  }, []);

  return handleDebounceScroll;
};

export default useDebounceScroll;
